import React, { createContext, useContext, useMemo } from "react";
import PropTypes from "prop-types";
//Limitless imports
import { useDevLogging } from "@limitless/common/hooks/dev-logging/DevLoggingContext";
import { useLoginWrapper } from "./LoginWrapperHook";
const LoginWrapperContext = /*#__PURE__*/createContext({});
export const LoginWrapperContextProvider = ({
  children
}) => {
  const {
    stateTracker
  } = useDevLogging();
  const loginWrapper = useLoginWrapper();
  const signInContext = useMemo(() => {
    stateTracker.trackState({
      loginWrapper
    });
    return {
      ...loginWrapper
    };
  }, [loginWrapper.mfaLoginState]);
  return /*#__PURE__*/React.createElement(LoginWrapperContext.Provider, {
    value: signInContext
  }, children);
};
export const useLoginWrapperContext = () => {
  return useContext(LoginWrapperContext);
};
LoginWrapperContextProvider.propTypes = {
  children: PropTypes.node.isRequired
};